import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';

import Menu from '../menu';
import Search from '@ifeng/ui_pc_search';
import UserInfo from '@ifeng/ui_pc_userInfo';
import auth from '@ifeng/ui_pc_auth';
import uploadIcon from '../../images/uploadLInk.jpg';
import manageIcon from '../../images/manageLink.jpg';
import myMideaIcon from '../../images/myMideaLink.jpg';
import dataIcon from '../../images/dataLink.jpg';

import NoSSR from 'react-no-ssr';

class Vlogo extends React.PureComponent {
    static propTypes = {
        // content: PropTypes.object,
    };

    render() {
        return (
            <div className={styles.vlogo}>
                <a
                    title="凤凰视频 v.ifeng.com"
                    href="http://v.ifeng.com/#_v_mininav_logo_pc"
                    target="_blank"
                    id="js_vtop_logo">
                    {/* <img
                        src="//p0.ifengimg.com/a/2017/0905/3e0cacbdf7611ddsize23_w676_h500.png"
                        title="凤凰视频 v.ifeng.com"
                    /> */}
                    凤凰视频
                </a>
            </div>
        );
    }
}

class UserCenter extends React.PureComponent {
    state = {
        linkData: [
            {
                title: '上传视频',
                url: 'https://fhh.ifeng.com/publish/article',
                logo: uploadIcon,
            },
            {
                title: '视频管理',
                url: 'https://fhh.ifeng.com/manage/video',
                logo: manageIcon,
            },
            {
                title: '我的自媒体',
                url: 'https://fhh.ifeng.com/index',
                logo: myMideaIcon,
            },
            {
                title: '数据分析',
                url: 'https://fhh.ifeng.com/stat/video',
                logo: dataIcon,
            },
        ],
    };

    render() {
        const { linkData } = this.state;

        return (
            <div className={`${styles.user} clearfix`}>
                <div className={styles.fll}>
                    <NoSSR>
                        <UserInfo option={['login', 'register']} />
                    </NoSSR>
                </div>
                <span className={styles.verticalLine}>|</span>
                <div className={styles.uplaodBtn}>
                    <div style={{ fontSize: '12px' }} id="uploadBtn" onMouseOver={this.handleClickUpload}>
                        上传
                        <div className={styles.uploadWrapper}>
                            <div className={styles.innerWrapper}>
                                {linkData.map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className={styles.linkItem}
                                            style={{
                                                margin: index === linkData.length - 1 ? '0 0 0 6px' : '0 6px',
                                            }}>
                                            <a href={item.url} target="_blank">
                                                <div className={styles.logo}>
                                                    <img src={item.logo} alt="" />
                                                </div>
                                                <div className={styles.linkTxt}>{item.title}</div>
                                            </a>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class SubHead extends React.PureComponent {
    static propTypes = {
        // content: PropTypes.object,
        search: PropTypes.array,
        navData: PropTypes.array,
    };

    state = {};

    componentDidMount() {
        // console.log(auth.isLogin());
    }

    render() {
        const { search, navData } = this.props;

        return (
            <div className={styles.vHeader}>
                <div className={styles.vHeaderInner}>
                    <Vlogo />
                    <NoSSR>
                        <Chip
                            id="140039"
                            type="struct"
                            title="视频底页-导航按钮"
                            groupName="导航按钮"
                            content={navData}>
                            <Menu content={navData} />
                        </Chip>
                    </NoSSR>
                    <div className={styles.searchBox}>
                        <NoSSR>
                            <Chip id="10129" type="static" title="通用搜索" groupName="头部" content={search}>
                                <Search />
                            </Chip>
                        </NoSSR>
                    </div>
                    <NoSSR>
                        <UserCenter />
                    </NoSSR>
                </div>
            </div>
        );
    }
}

export default errorBoundary(SubHead);
